import { render } from "./Questions.vue?vue&type=template&id=af53853e&scoped=true"
import script from "./Questions.vue?vue&type=script&lang=ts"
export * from "./Questions.vue?vue&type=script&lang=ts"

import "./Questions.vue?vue&type=style&index=0&id=af53853e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-af53853e"

export default script